import { render, staticRenderFns } from "./modulo3.vue?vue&type=template&id=24f7f2d9&scoped=true&"
import script from "./modulo3.vue?vue&type=script&lang=js&"
export * from "./modulo3.vue?vue&type=script&lang=js&"
import style0 from "./modulo3.vue?vue&type=style&index=0&id=24f7f2d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7f2d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
